// Admin contact information
export const ADMIN_CONFIG = {
  // WhatsApp number in international format (without +)
  // Format: countryCode + number (e.g., 212 for Morocco, 33 for France)
  WHATSAPP_NUMBER: '24177619251', // À remplacer par le numéro réel
  WHATSAPP_NUMBER_DISPLAY: '+241 77 61-92-51',
  EMAIL: 'support@libreshop.com',
  PHONE: '+241 77 61-92-51',
};

export default ADMIN_CONFIG;
